(function() {
  function fixAnnouncementBar() {
    var el = document.querySelector('animated-background-text-colors');
    if (!el) return;

    // Force background: #2B2B2B solid, cream text, no border/shadow
    el.style.setProperty('background-color', '#2B2B2B', 'important');
    el.style.setProperty('background', '#2B2B2B', 'important');
    el.style.setProperty('border', 'none', 'important');
    el.style.setProperty('box-shadow', 'none', 'important');
    el.style.setProperty('outline', 'none', 'important');

    // Force all text inside to cream
    var textEls = el.querySelectorAll('*');
    for (var i = 0; i < textEls.length; i++) {
      textEls[i].style.setProperty('color', '#F1EFDE', 'important');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAnnouncementBar);
  } else {
    fixAnnouncementBar();
  }
  setTimeout(fixAnnouncementBar, 100);
  setTimeout(fixAnnouncementBar, 500);
})();
